import React from 'react'
import { Button } from '@/components/ui/button'
import { X, ChevronUp, ChevronDown, MoreVertical } from 'lucide-react'
import { useRouter } from '@tanstack/react-router';
import { Route as piRoute } from "@/routes/(pharma)/_layout/inventory/purchase-invoice/$id/index"

const Header = () => {
  const router = useRouter();
    const params = piRoute.useParams()
    const search = piRoute.useSearch()
    const data = piRoute.useLoaderData()
    return (
      <div className="flex items-center justify-between pt-2 px-2">
        <div className="flex items-center gap-1">
          <Button variant="ghost" size="icon" onClick={() => {
            router.navigate({
              to: "/reports/purchase-invoice-list",
            })
          }}>
            <X className="h-4 w-4" />
          </Button>
          <Button variant="outline" size="sm" className='px-2' disabled={
            data.purchaseInvoice.previousPurchaseInvoiceId === "00000000-0000-0000-0000-000000000000"
          } onClick={() => {
            router.navigate({
              to: "/inventory/purchase-invoice/$id",
              params: {
                id: data.purchaseInvoice.previousPurchaseInvoiceId
              },
              search: {
                ...search,
              }
            })
          }}>
            <ChevronUp className="h-4 w-4" />
          </Button>
          <Button variant="outline" size="sm" className='px-2' disabled={
            data.purchaseInvoice.nextPurchaseInvoiceId === "00000000-0000-0000-0000-000000000000"
          } onClick={() => {
            router.navigate({
              to: "/inventory/purchase-invoice/$id",
              params: {
                id: data.purchaseInvoice.nextPurchaseInvoiceId
              },
              search: {
                ...search,
              }
            })
          }}>
            <ChevronDown className="h-4 w-4" />
          </Button>
          <p className='text-sm text-gray-600 ml-2'>{
              data.purchaseInvoice.currentIndex + 1
            } {" "} of {data.purchaseInvoice.totalCount} Purchase Invoices</p>
        </div>
        <Button variant="ghost" size="icon">
          <MoreVertical className="h-4 w-4" />
        </Button>
      </div>
    )
}

export default Header 